<template>
  <div class="container" v-if="trigger">
    <h5 class="title is-5">Trigger "{{trigger.name}}"</h5>
    <div class="container has-text-left">
      <div class="block">
        <b-field label="Name:">
          <b-input v-model="trigger.name" placeholder="Enter name for trigger" required />
        </b-field>
        <b-field label="Definition:">
          <b-input type="textarea" v-model="triggerDefinition" placeholder="Enter definition for trigger..." required :rows="20" />
        </b-field>
      </div>
      <div class="buttons">
        <b-button type="is-danger-outlined" @click="handleBack">Back</b-button>
        <b-button type="is-success" :disabled="!validFields()" @click="handleModify">Modify</b-button>
        <b-button type="is-danger" @click="handleDelete">Delete</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BInput,
      BField},
    name: "screen-configure-trigger",
    data() {
      return {
        trigger: null,
        triggerDefinition: ''
      };
    },
    computed: {
      ...mapGetters('triggers', ['triggerById'])
    },
    methods: {
      ...mapActions('triggers', ['modifyTrigger', 'deleteTrigger']),
      validFields() {
        return this.trigger.name.length > 1 && this.validDefinition();
      },
      validDefinition() {
        try {
          const def = JSON.parse(this.triggerDefinition);
          if (!def) {
            return false;
          }
        } catch (e) {
          return false;
        }

        return true;
      },
      handleBack() {
        this.$router.push('/configure/triggers');
      },
      handleModify() {
        this.modifyTrigger({
          id: this.trigger.id,
          name: this.trigger.name,
          definition: this.triggerDefinition
        });
        this.handleBack();
      },
      handleDelete() {
        if (confirm('Are you sure ?')) {
          this.deleteTrigger(this.trigger.id);
        }
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.trigger = this.triggerById(this.$route.params.id);
        this.triggerDefinition = this.trigger && this.trigger.definition ? JSON.stringify(this.trigger.definition) : '';
      }
    }
  }
</script>

<style scoped>

</style>